/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SysquePropertiesListModule } from '../../../../../../../shared/ui/src/lib/components/sysque-properties-list';
import { SysqueDropdownConnectorsModule } from '../../../../../../../shared/ui/src/lib/components/sysque-dropdown-connectors';
import { SysqueToggleButtonModule } from '../../../../../../../shared/ui/src/lib/components/sysque-switch-button';
import { SysqueTextBoxDescriptionModule } from '../../../../../../../shared/ui/src/lib/components/sysque-text-area-description';
import { SysqueDatagridSizeRangeModule } from '../../../../../../../shared/ui/src/lib/components/sysque-datagrid-size-range';
import { DxButtonModule, DxTabPanelModule } from 'devextreme-angular';
import { RouterModule, Routes } from '@angular/router';
import { HandAndMachineBendFamilyInformation } from './hand-and-machine-bend-family-information.component';
import { AlertModule } from '../../../../../../../shared/ui/src/lib/components/alert';


const routes: Routes = [{ path: 'dialog/hand-and-machine-bend-family-information-dialog', component: HandAndMachineBendFamilyInformation }];

@NgModule({
  declarations: [HandAndMachineBendFamilyInformation],
  imports: [
    CommonModule, 
    SysquePropertiesListModule,
    SysqueDropdownConnectorsModule,
    SysqueToggleButtonModule,
    SysqueTextBoxDescriptionModule,
    SysqueDatagridSizeRangeModule,
    DxButtonModule, 
    DxTabPanelModule,
    AlertModule, 
    RouterModule.forChild(routes)],
  exports: [HandAndMachineBendFamilyInformation],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class HandAndMachineBendFamilyInformationModule {}
